import {
  Zap, Droplets, Wind, SquareStack, PaintRoller, Grid3x3, PanelTop,
  Home, Hammer, BrickWall, Waves, Cctv, Settings, SquareParking,
} from "lucide-react";

export const SERVICES = [
  { id: "electrical", name: "Electrical", icon: Zap, blurb: "High & low voltage installation, maintenance and repair done to code." },
  { id: "plumbing", name: "Plumbing", icon: Droplets, blurb: "Commercial and residential plumbing installs, service and repairs." },
  { id: "hvac", name: "HVAC", icon: Wind, blurb: "Heating, ventilation and AC systems installed, serviced and repaired." },
  { id: "drywall", name: "Drywall / Sheetrock", icon: SquareStack, blurb: "Hang, finish and patch sheetrock for a flawless surface." },
  { id: "painting", name: "Painting", icon: PaintRoller, blurb: "Interior & exterior painting with a clean, durable finish." },
  { id: "tile", name: "Tile", icon: Grid3x3, blurb: "Floor and wall tile, backsplashes and custom layouts." },
  { id: "ceilings", name: "Drop / Grid Ceilings", icon: PanelTop, blurb: "Suspended grid and drop ceiling systems for any commercial space." },
  { id: "roofing", name: "Roofing", icon: Home, blurb: "Roof installation, maintenance and leak repair you can rely on." },
  { id: "buildouts", name: "Demo to Buildouts", icon: Hammer, blurb: "Full demolition through complete commercial buildouts." },
  { id: "masonry", name: "Stone Masonry", icon: BrickWall, blurb: "Stone, brick and block masonry built to last." },
  { id: "pressure-washing", name: "Pressure Washing", icon: Waves, blurb: "Restore surfaces, lots and facades with professional washing." },
  { id: "parking-lot-striping", name: "Parking Lot Striping", icon: SquareParking, blurb: "Crisp, code-compliant striping, stalls, ADA spots and markings." },
  { id: "security-cameras", name: "Security Cameras", icon: Cctv, blurb: "Camera and surveillance systems installed and serviced." },
  { id: "commercial-equipment", name: "Commercial Equipment", icon: Settings, blurb: "Installation and repair of all commercial equipment." },
];

export const COMPANY = {
  name: "Prowess Services",
  tagline: "The Quality is in the Details.",
  phoneDisplay: "(346) PROWESS",
  phoneSub: "(346) 776-9377",
  phoneHref: "tel:+13467769377",
  email: "Max@GoProwess.com",
  emailHref: "mailto:max@goprowess.com",
  website: "GoProwess.com",
  websiteHref: "https://goprowess.com",
};
